export enum CountriesAlpha2Enum {
  AD = 'Andorra',
  AE = 'United Arab Emirates',
  AF = 'Afghanistan',
  AG = 'Antigua and Barbuda',
  AI = 'Anguilla',
  AL = 'Albania',
  AM = 'Armenia',
  AO = 'Angola',
  AQ = 'Antarctica',
  AR = 'Argentina',
  AS = 'American Samoa',
  AT = 'Austria',
  AU = 'Australia',
  AW = 'Aruba',
  AX = 'Aland Islands',
  AZ = 'Azerbaijan',
  BA = 'Bosnia and Herzegovina',
  BB = 'Barbados',
  BD = 'Bangladesh',
  BE = 'Belgium',
  BF = 'Burkina Faso',
  BG = 'Bulgaria',
  BH = 'Bahrain',
  BI = 'Burundi',
  BJ = 'Benin',
  BL = 'Saint Barthelemy',
  BM = 'Bermuda',
  BN = 'Brunei',
  BO = 'Bolivia',
  BQ = 'Bonaire, Saint Eustatius and Saba ',
  BR = 'Brazil',
  BS = 'Bahamas',
  BT = 'Bhutan',
  BV = 'Bouvet Island',
  BW = 'Botswana',
  BY = 'Belarus',
  BZ = 'Belize',
  CA = 'Canada',
  CC = 'Cocos Islands',
  CD = 'Democratic Republic of the Congo',
  CF = 'Central African Republic',
  CG = 'Republic of the Congo',
  CH = 'Switzerland',
  CI = 'Ivory Coast',
  CK = 'Cook Islands',
  CL = 'Chile',
  CM = 'Cameroon',
  CN = 'China',
  CO = 'Colombia',
  CR = 'Costa Rica',
  CU = 'Cuba',
  CV = 'Cape Verde',
  CW = 'Curacao',
  CX = 'Christmas Island',
  CY = 'Cyprus',
  CZ = 'Czech Republic',
  DE = 'Germany',
  DJ = 'Djibouti',
  DK = 'Denmark',
  DM = 'Dominica',
  DO = 'Dominican Republic',
  DZ = 'Algeria',
  EC = 'Ecuador',
  EE = 'Estonia',
  EG = 'Egypt',
  EH = 'Western Sahara',
  ER = 'Eritrea',
  ES = 'Spain',
  ET = 'Ethiopia',
  FI = 'Finland',
  FJ = 'Fiji',
  FK = 'Falkland Islands',
  FM = 'Micronesia',
  FO = 'Faroe Islands',
  FR = 'France',
  GA = 'Gabon',
  GB = 'United Kingdom',
  GD = 'Grenada',
  GE = 'Georgia',
  GF = 'French Guiana',
  GG = 'Guernsey',
  GH = 'Ghana',
  GI = 'Gibraltar',
  GL = 'Greenland',
  GM = 'Gambia',
  GN = 'Guinea',
  GP = 'Guadeloupe',
  GQ = 'Equatorial Guinea',
  GR = 'Greece',
  GS = 'South Georgia and the South Sandwich Islands',
  GT = 'Guatemala',
  GU = 'Guam',
  GW = 'Guinea-Bissau',
  GY = 'Guyana',
  HK = 'Hong Kong',
  HM = 'Heard Island and McDonald Islands',
  HN = 'Honduras',
  HR = 'Croatia',
  HT = 'Haiti',
  HU = 'Hungary',
  ID = 'Indonesia',
  IE = 'Ireland',
  IL = 'Israel',
  IM = 'Isle of Man',
  IN = 'India',
  IO = 'British Indian Ocean Territory',
  IQ = 'Iraq',
  IR = 'Iran',
  IS = 'Iceland',
  IT = 'Italy',
  JE = 'Jersey',
  JM = 'Jamaica',
  JO = 'Jordan',
  JP = 'Japan',
  KE = 'Kenya',
  KG = 'Kyrgyzstan',
  KH = 'Cambodia',
  KI = 'Kiribati',
  KM = 'Comoros',
  KN = 'Saint Kitts and Nevis',
  KP = 'North Korea',
  KR = 'South Korea',
  KW = 'Kuwait',
  KY = 'Cayman Islands',
  KZ = 'Kazakhstan',
  LA = 'Laos',
  LB = 'Lebanon',
  LC = 'Saint Lucia',
  LI = 'Liechtenstein',
  LK = 'Sri Lanka',
  LR = 'Liberia',
  LS = 'Lesotho',
  LT = 'Lithuania',
  LU = 'Luxembourg',
  LV = 'Latvia',
  LY = 'Libya',
  MA = 'Morocco',
  MC = 'Monaco',
  MD = 'Moldova',
  ME = 'Montenegro',
  MF = 'Saint Martin',
  MG = 'Madagascar',
  MH = 'Marshall Islands',
  MK = 'Macedonia',
  ML = 'Mali',
  MM = 'Myanmar',
  MN = 'Mongolia',
  MO = 'Macao',
  MP = 'Northern Mariana Islands',
  MQ = 'Martinique',
  MR = 'Mauritania',
  MS = 'Montserrat',
  MT = 'Malta',
  MU = 'Mauritius',
  MV = 'Maldives',
  MW = 'Malawi',
  MX = 'Mexico',
  MY = 'Malaysia',
  MZ = 'Mozambique',
  NA = 'Namibia',
  NC = 'New Caledonia',
  NE = 'Niger',
  NF = 'Norfolk Island',
  NG = 'Nigeria',
  NI = 'Nicaragua',
  NL = 'Netherlands',
  NO = 'Norway',
  NP = 'Nepal',
  NR = 'Nauru',
  NU = 'Niue',
  NZ = 'New Zealand',
  OM = 'Oman',
  PA = 'Panama',
  PE = 'Peru',
  PF = 'French Polynesia',
  PG = 'Papua New Guinea',
  PH = 'Philippines',
  PK = 'Pakistan',
  PL = 'Poland',
  PM = 'Saint Pierre and Miquelon',
  PN = 'Pitcairn',
  PR = 'Puerto Rico',
  PS = 'Palestinian Territory',
  PT = 'Portugal',
  PW = 'Palau',
  PY = 'Paraguay',
  QA = 'Qatar',
  RE = 'Réunion',
  RO = 'Romania',
  RS = 'Serbia',
  RU = 'Russia',
  RW = 'Rwanda',
  SA = 'Saudi Arabia',
  SB = 'Solomon Islands',
  SC = 'Seychelles',
  SD = 'Sudan',
  SE = 'Sweden',
  SG = 'Singapore',
  SH = 'Saint Helena',
  SI = 'Slovenia',
  SJ = 'Svalbard and Jan Mayen',
  SK = 'Slovakia',
  SL = 'Sierra Leone',
  SM = 'San Marino',
  SN = 'Senegal',
  SO = 'Somalia',
  SR = 'Suriname',
  SS = 'South Sudan',
  ST = 'Sao Tome and Principe',
  SV = 'El Salvador',
  SX = 'Sint Maarten',
  SY = 'Syria',
  SZ = 'Swaziland',
  TC = 'Turks and Caicos Islands',
  TD = 'Chad',
  TF = 'French Southern Territories',
  TG = 'Togo',
  TH = 'Thailand',
  TJ = 'Tajikistan',
  TK = 'Tokelau',
  TL = 'East Timor',
  TM = 'Turkmenistan',
  TN = 'Tunisia',
  TO = 'Tonga',
  TR = 'Turkey',
  TT = 'Trinidad and Tobago',
  TV = 'Tuvalu',
  TW = 'Taiwan',
  TZ = 'Tanzania',
  UA = 'Ukraine',
  UG = 'Uganda',
  UM = 'United States Minor Outlying Islands',
  US = 'United States',
  UY = 'Uruguay',
  UZ = 'Uzbekistan',
  VA = 'Vatican',
  VC = 'Saint Vincent and the Grenadines',
  VE = 'Venezuela',
  VG = 'Virgin Islands (British)',
  VI = 'Virgin Islands (U.S.)',
  VN = 'Vietnam',
  VU = 'Vanuatu',
  WF = 'Wallis and Futuna',
  WS = 'Samoa',
  XK = 'Kosovo',
  YE = 'Yemen',
  YT = 'Mayotte',
  ZA = 'South Africa',
  ZM = 'Zambia',
  ZW = 'Zimbabwe',
}

export enum CountriesAlpha3Enum {
  ABW = 'Aruba',
  AFG = 'Afghanistan',
  AGO = 'Angola',
  AIA = 'Anguilla',
  ALA = 'Aland Islands',
  ALB = 'Albania',
  AND = 'Andorra',
  ARE = 'United Arab Emirates',
  ARG = 'Argentina',
  ARM = 'Armenia',
  ASM = 'American Samoa',
  ATA = 'Antarctica',
  ATF = 'French Southern Territories',
  ATG = 'Antigua and Barbuda',
  AUS = 'Australia',
  AUT = 'Austria',
  AZE = 'Azerbaijan',
  BDI = 'Burundi',
  BEL = 'Belgium',
  BEN = 'Benin',
  BFA = 'Burkina Faso',
  BGD = 'Bangladesh',
  BGR = 'Bulgaria',
  BHR = 'Bahrain',
  BHS = 'Bahamas',
  BIH = 'Bosnia and Herzegovina',
  BLM = 'Saint Barthelemy',
  BLR = 'Belarus',
  BLZ = 'Belize',
  BMU = 'Bermuda',
  BOL = 'Bolivia',
  BRA = 'Brazil',
  BRB = 'Barbados',
  BRN = 'Brunei Darussalam',
  BTN = 'Bhutan',
  BVT = 'Bouvet Island',
  BWA = 'Botswana',
  CAF = 'Central African Republic',
  CAN = 'Canada',
  CCK = 'Cocos Keeling Islands',
  CUW = 'Curaçao',
  CHE = 'Switzerland',
  CHL = 'Chile',
  CHN = 'China',
  CIV = "Cote D'Ivoire",
  CMR = 'Cameroon',
  COD = 'Congo Democratic Republic',
  COG = 'Congo',
  COK = 'Cook Islands',
  COL = 'Colombia',
  COM = 'Comoros',
  CPV = 'Cape Verde',
  CRI = 'Costa Rica',
  CUB = 'Cuba',
  CXR = 'Christmas Island',
  CYM = 'Cayman Islands',
  CYP = 'Cyprus',
  CZE = 'Czech Republic',
  DEU = 'Germany',
  DJI = 'Djibouti',
  DMA = 'Dominica',
  DNK = 'Denmark',
  DOM = 'Dominican Republic',
  DZA = 'Algeria',
  ECU = 'Ecuador',
  EGY = 'Egypt',
  ERI = 'Eritrea',
  ESH = 'Western Sahara',
  ESP = 'Spain',
  EST = 'Estonia',
  ETH = 'Ethiopia',
  FIN = 'Finland',
  FJI = 'Fiji',
  FLK = 'Falkland Islands',
  FRA = 'France',
  FRO = 'Faroe Islands',
  FSM = 'Micronesia',
  GAB = 'Gabon',
  GBR = 'United Kingdom',
  GEO = 'Georgia',
  GGY = 'Guernsey',
  GHA = 'Ghana',
  GIB = 'Gibraltar',
  GIN = 'Guinea',
  GLP = 'Guadeloupe',
  GMB = 'Gambia',
  GNB = 'Guinea Bissau',
  GNQ = 'Equatorial Guinea',
  GRC = 'Greece',
  GRD = 'Grenada',
  GRL = 'Greenland',
  GTM = 'Guatemala',
  GUF = 'French Guiana',
  GUM = 'Guam',
  GUY = 'Guyana',
  HKG = 'Hong Kong',
  HMD = 'Heard Island Mcdonald Islands',
  HND = 'Honduras',
  HRV = 'Croatia',
  HTI = 'Haiti',
  HUN = 'Hungary',
  IDN = 'Indonesia',
  IMN = 'Isle Of Man',
  IND = 'India',
  IOT = 'British Indian Ocean Territory',
  IRL = 'Ireland',
  IRN = 'Iran',
  IRQ = 'Iraq',
  ISL = 'Iceland',
  ISR = 'Israel',
  ITA = 'Italy',
  JAM = 'Jamaica',
  JEY = 'Jersey',
  JOR = 'Jordan',
  JPN = 'Japan',
  KAZ = 'Kazakhstan',
  KEN = 'Kenya',
  KGZ = 'Kyrgyzstan',
  KHM = 'Cambodia',
  KIR = 'Kiribati',
  KNA = 'Saint Kitts And Nevis',
  KOR = 'Korea, Republic of',
  KWT = 'Kuwait',
  LAO = 'Lao Peoples Democratic Republic',
  LBN = 'Lebanon',
  LBR = 'Liberia',
  LBY = 'Libyan Arab Jamahiriya',
  LCA = 'Saint Lucia',
  LIE = 'Liechtenstein',
  LKA = 'Sri Lanka',
  LSO = 'Lesotho',
  LTU = 'Lithuania',
  LUX = 'Luxembourg',
  LVA = 'Latvia',
  MAC = 'Macao',
  MAF = 'Saint Martin',
  MAR = 'Morocco',
  MCO = 'Monaco',
  MDA = 'Moldova',
  MDG = 'Madagascar',
  MDV = 'Maldives',
  MEX = 'Mexico',
  MHL = 'Marshall Islands',
  MKD = 'North Macedonia',
  MLI = 'Mali',
  MLT = 'Malta',
  MMR = 'Myanmar',
  MNE = 'Montenegro',
  MNG = 'Mongolia',
  MNP = 'Northern Mariana Islands',
  MOZ = 'Mozambique',
  MRT = 'Mauritania',
  MSR = 'Montserrat',
  MTQ = 'Martinique',
  MUS = 'Mauritius',
  MWI = 'Malawi',
  MYS = 'Malaysia',
  MYT = 'Mayotte',
  NAM = 'Namibia',
  NCL = 'New Caledonia',
  NER = 'Niger',
  NFK = 'Norfolk Island',
  NGA = 'Nigeria',
  NIC = 'Nicaragua',
  NIU = 'Niue',
  NLD = 'Netherlands',
  NOR = 'Norway',
  NPL = 'Nepal',
  NRU = 'Nauru',
  NZL = 'New Zealand',
  OMN = 'Oman',
  PAK = 'Pakistan',
  PAN = 'Panama',
  PCN = 'Pitcairn',
  PER = 'Peru',
  PHL = 'Philippines',
  PLW = 'Palau',
  PNG = 'Papua New Guinea',
  POL = 'Poland',
  PRI = 'Puerto Rico',
  PRK = "Korea, Democratic People's Republic of",
  PRT = 'Portugal',
  PRY = 'Paraguay',
  PSE = 'Palestinian Territory',
  PYF = 'French Polynesia',
  QAT = 'Qatar',
  REU = 'Réunion',
  ROU = 'Romania',
  RUS = 'Russian Federation',
  RWA = 'Rwanda',
  SAU = 'Saudi Arabia',
  SDN = 'Sudan',
  SEN = 'Senegal',
  SGP = 'Singapore',
  SGS = 'South Georgia And Sandwich Island',
  SHN = 'Saint Helena',
  SJM = 'Svalbard And Jan Mayen',
  SLB = 'Solomon Islands',
  SLE = 'Sierra Leone',
  SLV = 'El Salvador',
  SMR = 'San Marino',
  SOM = 'Somalia',
  SPM = 'Saint Pierre And Miquelon',
  SRB = 'Serbia',
  SSD = 'South Sudan',
  STP = 'Sao Tome And Principe',
  SUR = 'Suriname',
  SVK = 'Slovakia',
  SVN = 'Slovenia',
  SWE = 'Sweden',
  SWZ = 'Swaziland',
  SXM = 'Sint Maarten (Dutch part)',
  SYC = 'Seychelles',
  SYR = 'Syrian Arab Republic',
  TCA = 'Turks And Caicos Islands',
  TCD = 'Chad',
  TGO = 'Togo',
  THA = 'Thailand',
  TJK = 'Tajikistan',
  TKL = 'Tokelau',
  TKM = 'Turkmenistan',
  TLS = 'Timor-Leste',
  TON = 'Tonga',
  TTO = 'Trinidad And Tobago',
  TUN = 'Tunisia',
  TUR = 'Turkey',
  TUV = 'Tuvalu',
  TWN = 'Taiwan',
  TZA = 'Tanzania',
  UGA = 'Uganda',
  UKR = 'Ukraine',
  UMI = 'United States Outlying Islands',
  URY = 'Uruguay',
  USA = 'United States',
  UZB = 'Uzbekistan',
  VAT = 'Holy See Vatican City State',
  VCT = 'Saint Vincent And Grenadines',
  VEN = 'Venezuela',
  VGB = 'Virgin Islands (British)',
  VIR = 'Virgin Islands (U.S.)',
  VNM = 'Vietnam',
  VUT = 'Vanuatu',
  WLF = 'Wallis And Futuna',
  WSM = 'Samoa',
  XKX = 'Kosovo',
  YEM = 'Yemen',
  ZAF = 'South Africa',
  ZMB = 'Zambia',
  ZWE = 'Zimbabwe',
}

export enum CountryAlpha3toAlpha2Enum {
  ABW = 'AW',
  AFG = 'AF',
  AGO = 'AO',
  AIA = 'AI',
  ALA = 'AX',
  ALB = 'AL',
  AND = 'AD',
  ANT = 'AN',
  ARE = 'AE',
  ARG = 'AR',
  ARM = 'AM',
  ASM = 'AS',
  ATA = 'AQ',
  ATF = 'TF',
  ATG = 'AG',
  AUS = 'AU',
  AUT = 'AT',
  AZE = 'AZ',
  BDI = 'BI',
  BEL = 'BE',
  BEN = 'BJ',
  BES = 'BQ',
  BFA = 'BF',
  BGD = 'BD',
  BGR = 'BG',
  BHR = 'BH',
  BHS = 'BS',
  BIH = 'BA',
  BLM = 'BL',
  BLR = 'BY',
  BLZ = 'BZ',
  BMU = 'BM',
  BOL = 'BO',
  BRA = 'BR',
  BRB = 'BB',
  BRN = 'BN',
  BTN = 'BT',
  BVT = 'BV',
  BWA = 'BW',
  CAF = 'CF',
  CAN = 'CA',
  CCK = 'CC',
  CHE = 'CH',
  CHL = 'CL',
  CHN = 'CN',
  CIV = 'CI',
  CMR = 'CM',
  COD = 'CD',
  COG = 'CG',
  COK = 'CK',
  COL = 'CO',
  COM = 'KM',
  CPV = 'CV',
  CRI = 'CR',
  CUB = 'CU',
  CUW = 'CW',
  CXR = 'CX',
  CYM = 'KY',
  CYP = 'CY',
  CZE = 'CZ',
  DEU = 'DE',
  DJI = 'DJ',
  DMA = 'DM',
  DNK = 'DK',
  DOM = 'DO',
  DZA = 'DZ',
  ECU = 'EC',
  EGY = 'EG',
  ERI = 'ER',
  ESH = 'EH',
  ESP = 'ES',
  EST = 'EE',
  ETH = 'ET',
  FIN = 'FI',
  FJI = 'FJ',
  FLK = 'FK',
  FRA = 'FR',
  FRO = 'FO',
  FSM = 'FM',
  GAB = 'GA',
  GBR = 'GB',
  GEO = 'GE',
  GGY = 'GG',
  GHA = 'GH',
  GIB = 'GI',
  GIN = 'GN',
  GLP = 'GP',
  GMB = 'GM',
  GNB = 'GW',
  GNQ = 'GQ',
  GRC = 'GR',
  GRD = 'GD',
  GRL = 'GL',
  GTM = 'GT',
  GUF = 'GF',
  GUM = 'GU',
  GUY = 'GY',
  HKG = 'HK',
  HMD = 'HM',
  HND = 'HN',
  HRV = 'HR',
  HTI = 'HT',
  HUN = 'HU',
  IDN = 'ID',
  IMN = 'IM',
  IND = 'IN',
  IOT = 'IO',
  IRL = 'IE',
  IRN = 'IR',
  IRQ = 'IQ',
  ISL = 'IS',
  ISR = 'IL',
  ITA = 'IT',
  JAM = 'JM',
  JEY = 'JE',
  JOR = 'JO',
  JPN = 'JP',
  KAZ = 'KZ',
  KEN = 'KE',
  KGZ = 'KG',
  KHM = 'KH',
  KIR = 'KI',
  KNA = 'KN',
  KOR = 'KR',
  KWT = 'KW',
  LAO = 'LA',
  LBN = 'LB',
  LBR = 'LR',
  LBY = 'LY',
  LCA = 'LC',
  LIE = 'LI',
  LKA = 'LK',
  LSO = 'LS',
  LTU = 'LT',
  LUX = 'LU',
  LVA = 'LV',
  MAC = 'MO',
  MAF = 'MF',
  MAR = 'MA',
  MCO = 'MC',
  MDA = 'MD',
  MDG = 'MG',
  MDV = 'MV',
  MEX = 'MX',
  MHL = 'MH',
  MKD = 'MK',
  MLI = 'ML',
  MLT = 'MT',
  MMR = 'MM',
  MNE = 'ME',
  MNG = 'MN',
  MNP = 'MP',
  MOZ = 'MZ',
  MRT = 'MR',
  MSR = 'MS',
  MTQ = 'MQ',
  MUS = 'MU',
  MWI = 'MW',
  MYS = 'MY',
  MYT = 'YT',
  NAM = 'NA',
  NCL = 'NC',
  NER = 'NE',
  NFK = 'NF',
  NGA = 'NG',
  NIC = 'NI',
  NIU = 'NU',
  NLD = 'NL',
  NOR = 'NO',
  NPL = 'NP',
  NRU = 'NR',
  NZL = 'NZ',
  OMN = 'OM',
  PAK = 'PK',
  PAN = 'PA',
  PCN = 'PN',
  PER = 'PE',
  PHL = 'PH',
  PLW = 'PW',
  PNG = 'PG',
  POL = 'PL',
  PRI = 'PR',
  PRK = 'KP',
  PRT = 'PT',
  PRY = 'PY',
  PSE = 'PS',
  PYF = 'PF',
  QAT = 'QA',
  REU = 'RE',
  ROU = 'RO',
  RUS = 'RU',
  RWA = 'RW',
  SAU = 'SA',
  SDN = 'SD',
  SEN = 'SN',
  SGP = 'SG',
  SGS = 'GS',
  SHN = 'SH',
  SJM = 'SJ',
  SLB = 'SB',
  SLE = 'SL',
  SLV = 'SV',
  SMR = 'SM',
  SOM = 'SO',
  SPM = 'PM',
  SRB = 'RS',
  SSD = 'SS',
  STP = 'ST',
  SUR = 'SR',
  SVK = 'SK',
  SVN = 'SI',
  SWE = 'SE',
  SWZ = 'SZ',
  SXM = 'SX',
  SYC = 'SC',
  SYR = 'SY',
  TCA = 'TC',
  TCD = 'TD',
  TGO = 'TG',
  THA = 'TH',
  TJK = 'TJ',
  TKL = 'TK',
  TKM = 'TM',
  TLS = 'TL',
  TON = 'TO',
  TTO = 'TT',
  TUN = 'TN',
  TUR = 'TR',
  TUV = 'TV',
  TWN = 'TW',
  TZA = 'TZ',
  UGA = 'UG',
  UKR = 'UA',
  UMI = 'UM',
  URY = 'UY',
  USA = 'US',
  UZB = 'UZ',
  VAT = 'VA',
  VCT = 'VC',
  VEN = 'VE',
  VGB = 'VG',
  VIR = 'VI',
  VNM = 'VN',
  VUT = 'VU',
  WLF = 'WF',
  WSM = 'WS',
  XKX = 'XK',
  YEM = 'YE',
  ZAF = 'ZA',
  ZMB = 'ZM',
  ZWE = 'ZW',
}

/**
 * Countries blocked from money movement, mirroring monorail's USD external-account
 * gate: Restrictions::CountryLists::SANCTIONED_COUNTRIES + PROHIBITED_COUNTRIES +
 * Compliance::Policy::Base::UNSUPPORTED_COUNTRIES (its default list, which is
 * Compliance::Policy::UNSUPPORTED_COUNTRIES_FOR_US_RAILS). Used to hide
 * countries from pickers the backend would otherwise reject. Keep in sync with those
 * lists; per-developer UNSUPPORTED overrides are not reflected here.
 */
export enum BannedCountryAlpha3Enum {
  AFG = 'Afghanistan',
  BDI = 'Burundi',
  BGD = 'Bangladesh',
  BLR = 'Belarus',
  BTN = 'Bhutan',
  CHN = 'China',
  COD = 'Congo Democratic Republic',
  CUB = 'Cuba',
  DZA = 'Algeria',
  GNB = 'Guinea-Bissau',
  HTI = 'Haiti',
  IRN = 'Iran',
  IRQ = 'Iraq',
  JPN = 'Japan',
  KEN = 'Kenya',
  LBN = 'Lebanon',
  LBY = 'Libya',
  MAR = 'Morocco',
  MMR = 'Myanmar',
  MOZ = 'Mozambique',
  NER = 'Niger',
  NPL = 'Nepal',
  PAK = 'Pakistan',
  PRK = 'North Korea',
  PSE = 'Palestinian Territory',
  QAT = 'Qatar',
  RUS = 'Russia',
  SDN = 'Sudan',
  SOM = 'Somalia',
  SSD = 'South Sudan',
  SYR = 'Syria',
  TUN = 'Tunisia',
  VEN = 'Venezuela',
  XKX = 'Kosovo',
  YEM = 'Yemen',
  ZWE = 'Zimbabwe',
}

/**
 * Alpha-3 codes monorail rejects for an external account's beneficiary address,
 * mirroring `Restrictions::CountryRiskTier.effectively_prohibited?` — the
 * `Prohibited` tier (CountryLists::SANCTIONED_COUNTRIES + PROHIBITED_COUNTRIES)
 * plus CountryLists::EFFECTIVELY_PROHIBITED_COUNTRIES. Countries absent from the
 * tier map default to `High`, which passes, so this set is exhaustive.
 *
 * Deliberately narrower than `BannedCountryAlpha3Enum`, which additionally folds in
 * `Compliance::Policy::Base::UNSUPPORTED_COUNTRIES`. That list gates a *customer's*
 * own physical/incorporation/residential address, not a beneficiary address, so it
 * must not narrow this picker. Keep both in sync with their respective backends.
 */
export const PROHIBITED_BENEFICIARY_ADDRESS_ALPHA3: ReadonlySet<string> = new Set([
  // SANCTIONED_COUNTRIES
  'BLR', 'CUB', 'IRN', 'MMR', 'PRK', 'RUS', 'SYR',
  // PROHIBITED_COUNTRIES
  'AFG', 'COD', 'IRQ', 'LBN', 'LBY', 'PSE', 'SDN', 'SOM', 'SSD', 'VEN', 'YEM',
  // EFFECTIVELY_PROHIBITED_COUNTRIES
  'BDI', 'CHN', 'DZA', 'JPN', 'TUN',
]);

/**
 * Alpha-3 codes where SWIFT bank accounts are supported when the developer's
 * offramp routes through Banking Circle. Mirrors the authoritative allowlist in
 * monorail SwiftHelper::SUPPORTED_COUNTRIES
 * (packs/external_accounts/app/public/swift_helper.rb); keep the two in sync.
 *
 * This is the default list — it applies to every developer without the
 * `CanUseSwift3ppOfframpGate` feature gate. Gated developers route to BNY and
 * get {@link SWIFT_BNY_SUPPORTED_ALPHA3} instead.
 */
export const SWIFT_SUPPORTED_ALPHA3: ReadonlySet<string> = new Set([
  'ALA', 'ARE', 'ARG', 'AUS', 'AUT', 'BEL', 'BLM', 'BRN', 'CAN', 'CHE',
  'CHL', 'CRI', 'CYP', 'DEU', 'DMA', 'DNK', 'ECU', 'ESP', 'EST', 'FIN',
  'FLK', 'FRA', 'FRO', 'GBR', 'GRC', 'GRL', 'HMD', 'HUN', 'IRL', 'ISL',
  'ISR', 'ITA', 'JPN', 'KOR', 'LIE', 'LTU', 'LUX', 'LVA', 'MAF', 'MNE',
  'NCL', 'NLD', 'NOR', 'NZL', 'PCN', 'POL', 'PRT', 'ROU', 'SGP', 'SGS',
  'SJM', 'SMR', 'SPM', 'SVK', 'SVN', 'SWE', 'TWN', 'UMI', 'URY', 'USA',
  'VCT', 'WLF',
]);

/**
 * Alpha-3 codes where SWIFT bank accounts are supported when the developer's
 * offramp routes through BNY (the 3PP vendor). Mirrors the authoritative
 * allowlist in monorail SwiftHelper::BNY_OFFRAMP_SUPPORTED_COUNTRIES
 * (packs/external_accounts/app/public/swift_helper.rb); keep the two in sync.
 *
 * Selected per-developer at request time by
 * `SwiftHelper.offramp_country_supported?(country:, developer:)` — BNY when the
 * developer has `CanUseSwift3ppOfframpGate`, Banking Circle otherwise. It is a
 * superset of {@link SWIFT_SUPPORTED_ALPHA3} apart from 16 Banking-Circle-only
 * territories (ALA, BLM, FLK, FRO, GRL, HMD, LIE, MAF, MNE, PCN, SGS, SJM, SMR,
 * SPM, UMI, WLF) that BNY rejects.
 */
export const SWIFT_BNY_SUPPORTED_ALPHA3: ReadonlySet<string> = new Set([
  'ABW', 'AGO', 'ALB', 'ARE', 'ARG', 'ARM', 'ATG', 'AUS', 'AUT', 'AZE',
  'BDI', 'BEL', 'BEN', 'BFA', 'BGD', 'BGR', 'BHR', 'BHS', 'BLZ', 'BMU',
  'BOL', 'BRA', 'BRN', 'BWA', 'CAN', 'CHE', 'CHL', 'CHN', 'CIV', 'CMR',
  'COL', 'CRI', 'CUW', 'CYM', 'CYP', 'CZE', 'DEU', 'DJI', 'DMA', 'DNK',
  'DOM', 'DZA', 'ECU', 'EGY', 'ERI', 'ESP', 'EST', 'ETH', 'FIN', 'FJI',
  'FRA', 'GAB', 'GBR', 'GEO', 'GHA', 'GIN', 'GMB', 'GNB', 'GRC', 'GRD',
  'GTM', 'GUY', 'HKG', 'HND', 'HRV', 'HTI', 'HUN', 'IDN', 'IND', 'IRL',
  'ISL', 'ISR', 'ITA', 'JAM', 'JOR', 'JPN', 'KAZ', 'KEN', 'KGZ', 'KHM',
  'KNA', 'KOR', 'KWT', 'LAO', 'LBR', 'LCA', 'LKA', 'LSO', 'LTU', 'LUX',
  'LVA', 'MAC', 'MAR', 'MDG', 'MDV', 'MEX', 'MLI', 'MLT', 'MNG', 'MOZ',
  'MRT', 'MUS', 'MWI', 'MYS', 'NAM', 'NCL', 'NER', 'NGA', 'NIC', 'NLD',
  'NOR', 'NPL', 'NZL', 'OMN', 'PAK', 'PAN', 'PER', 'PHL', 'PNG', 'POL',
  'PRT', 'PRY', 'PYF', 'QAT', 'ROU', 'RWA', 'SAU', 'SEN', 'SGP', 'SLB',
  'SLV', 'SRB', 'SUR', 'SVK', 'SVN', 'SWE', 'SWZ', 'SYC', 'TGO', 'THA',
  'TJK', 'TTO', 'TUN', 'TUR', 'TWN', 'TZA', 'UGA', 'URY', 'USA', 'VCT',
  'VNM', 'VUT', 'WSM', 'ZAF', 'ZMB',
]);

/**
 * Countries in the SEPA zone, mirroring monorail's
 * `Geography::SepaHelper::SEPA_ZONE_COUNTRIES`
 * (packs/geography/app/public/sepa_helper.rb) — the list the backend validates
 * `iban.country` against when creating a SEPA external account. Keep the two in sync.
 *
 * This must stay an exact mirror, not a superset. `CreateExternalAccount` rejects an
 * unlisted country with a 400 on `iban.country`, so any extra code here is a dropdown
 * entry that can only fail at submit.
 */
export enum SepaCountryAlpha3Enum {
  ALA = 'Aland Islands',
  ALB = 'Albania',
  AND = 'Andorra',
  AUT = 'Austria',
  BEL = 'Belgium',
  BGR = 'Bulgaria',
  BLM = 'Saint Barthelemy',
  CHE = 'Switzerland',
  CYP = 'Cyprus',
  CZE = 'Czech Republic',
  DEU = 'Germany',
  DNK = 'Denmark',
  ESP = 'Spain',
  EST = 'Estonia',
  FIN = 'Finland',
  FRA = 'France',
  GBR = 'United Kingdom',
  GGY = 'Guernsey',
  GIB = 'Gibraltar',
  GRC = 'Greece',
  HRV = 'Croatia',
  HUN = 'Hungary',
  IMN = 'Isle Of Man',
  IRL = 'Ireland',
  ISL = 'Iceland',
  ITA = 'Italy',
  JEY = 'Jersey',
  LIE = 'Liechtenstein',
  LTU = 'Lithuania',
  LUX = 'Luxembourg',
  LVA = 'Latvia',
  MAF = 'Saint Martin',
  MCO = 'Monaco',
  MDA = 'Moldova',
  MKD = 'North Macedonia',
  MLT = 'Malta',
  MNE = 'Montenegro',
  MYT = 'Mayotte',
  NLD = 'Netherlands',
  NOR = 'Norway',
  POL = 'Poland',
  PRT = 'Portugal',
  REU = 'Réunion',
  ROU = 'Romania',
  SMR = 'San Marino',
  SPM = 'Saint Pierre And Miquelon',
  SRB = 'Serbia',
  SVK = 'Slovakia',
  SVN = 'Slovenia',
  SWE = 'Sweden',
  VAT = 'Holy See Vatican City State',
}

const alphaToFlagAlpha = (a: string) => String.fromCodePoint(0x1f1a5 + a.toUpperCase().codePointAt(0)!);
export const emojiFlag = (countryCode: string) => countryCode.slice(0, 2).split('').map(alphaToFlagAlpha).join('');

export const BANNED_COUNTRIES = Object.entries(BannedCountryAlpha3Enum);
export const ACTIVE_COUNTRIES = Object.entries(CountriesAlpha3Enum)
  .filter(([key]) => !(key in BannedCountryAlpha3Enum))
  .sort((a, b) => a[1].localeCompare(b[1]));
export const SWIFT_COUNTRIES = Object.entries(CountriesAlpha3Enum)
  .filter(([key]) => SWIFT_SUPPORTED_ALPHA3.has(key))
  .sort((a, b) => a[1].localeCompare(b[1]));
export const SWIFT_BNY_COUNTRIES = Object.entries(CountriesAlpha3Enum)
  .filter(([key]) => SWIFT_BNY_SUPPORTED_ALPHA3.has(key))
  .sort((a, b) => a[1].localeCompare(b[1]));
export const SEPA_COUNTRIES = Object.entries(SepaCountryAlpha3Enum)
  .filter(([key]) => !(key in BannedCountryAlpha3Enum))
  .sort((a, b) => a[1].localeCompare(b[1]));
export const BENEFICIARY_ADDRESS_COUNTRIES = Object.entries(CountriesAlpha3Enum)
  .filter(([key]) => !PROHIBITED_BENEFICIARY_ADDRESS_ALPHA3.has(key))
  .sort((a, b) => a[1].localeCompare(b[1]));

function getCountryOptions(countries: [string, string][], withFlag: boolean = false) {
  return countries.map(([code, name]) => ({
    label: withFlag
      ? `${name} ${emojiFlag(CountryAlpha3toAlpha2Enum[code as keyof typeof CountryAlpha3toAlpha2Enum])}`
      : name,
    value: code,
  }));
}

export const ALL_COUNTRY_OPTIONS = getCountryOptions(ACTIVE_COUNTRIES);
export const ALL_COUNTRY_OPTIONS_WITH_FLAG = getCountryOptions(ACTIVE_COUNTRIES, true);
export const SWIFT_COUNTRY_OPTIONS = getCountryOptions(SWIFT_COUNTRIES);
export const SWIFT_COUNTRY_OPTIONS_WITH_FLAG = getCountryOptions(SWIFT_COUNTRIES, true);
export const SWIFT_BNY_COUNTRY_OPTIONS = getCountryOptions(SWIFT_BNY_COUNTRIES);
export const SWIFT_BNY_COUNTRY_OPTIONS_WITH_FLAG = getCountryOptions(SWIFT_BNY_COUNTRIES, true);
export const SEPA_COUNTRY_OPTIONS = getCountryOptions(SEPA_COUNTRIES);
export const SEPA_COUNTRY_OPTIONS_WITH_FLAG = getCountryOptions(SEPA_COUNTRIES, true);
export const BENEFICIARY_ADDRESS_COUNTRY_OPTIONS = getCountryOptions(BENEFICIARY_ADDRESS_COUNTRIES);
export const BENEFICIARY_ADDRESS_COUNTRY_OPTIONS_WITH_FLAG = getCountryOptions(BENEFICIARY_ADDRESS_COUNTRIES, true);
